import { render, staticRenderFns } from "./modal-alert.vue?vue&type=template&id=626d0a0e&"
import script from "./modal-alert.vue?vue&type=script&lang=js&"
export * from "./modal-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports